import { gql } from 'graphql-request';

export const updateOrderMutation = gql`
    mutation updateOrder($uuid: String!, $email: String!) {
        updateOrder(uuid: $uuid, email: $email) {
            signIframeUrl
        }
    }
`;
